module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust2_m_en.97ffd0e67be9aa4a9f81399f1198c7dc.png";